import i18n from 'src/i18n';
import styled from 'styled-components';
import { bellImage } from 'views/practitioner/services/svgImages';

const SnackWrapper = styled.div`
  font-size: 0.9em;
  display: flex;
  align-items: center;
  background: red;
  position: fixed;
  min-width: 350px;
  bottom: 30px;
  border-radius: 4px;
  left: 50vw;
  transform: translate(-50%);
  box-sizing: border-box;
  z-index: ${p => (p.isShow ? 10 : -1)};
  padding: 1em 0.7em;
  background: ${(p) => p.theme.color.text};
  box-shadow: 0px 2px 2px 2px rgba(0, 0, 0, 0.03);
  color: white;
  opacity: ${p => (p.isShow ? 1 : 0)};
  transition: opacity 0.25s ease-in-out;
  left: 50vw;
  transform: translate(-50%);
  &:hover {
    cursor: ${p => (p.onClose ? 'pointer' : 'default')};
  }
`;

export default props => {
  const { isShow, onClose } = props;
  return (
    <SnackWrapper isShow={isShow} onClick={onClose}>
      {bellImage(true, false, true)}
      <span style={{ paddingLeft: '0.8em' }}>{i18n.t('unplanned_arrivals_available')}</span>
    </SnackWrapper>
  );
};
